import React from 'react';

export interface ShapeMarkerProps {
  x: number;
  y: number;
  width: number;
  height: number;
  borderRadius?: number | string;
  borderWidth?: number;
  borderColor?: string;
  rotation?: number;
  opacity?: number;
}

export const ShapeMarker: React.FC<ShapeMarkerProps> = ({
  x,
  y,
  width,
  height,
  borderRadius = 0,
  borderWidth = 10,
  borderColor = '#f52e2e',
  rotation = 0,
  opacity = 1,
}) => {
  return (
    <div
      style={{
        position: 'absolute',
        left: x,
        top: y,
        width,
        height,
        opacity,
        backgroundColor: 'transparent',
        border: `${borderWidth}px solid ${borderColor}`,
        borderRadius,
        boxSizing: 'border-box',
        transform: `rotate(${rotation}deg)`,
        pointerEvents: 'none',
      }}
    />
  );
};
